module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-10.75c79fb9.png";